namespace GeniuzPOS.AdvPromo {
    export class Report_Adv02Columns {
        static columnsKey = 'AdvPromo.Report_Adv02';
    }
}
